const CostCenters = () => import('./CostCenters.vue')
const CostCenterDetails = () => import('./CostCenterDetails.vue')

export default [
  {
    name: 'cost-centers',
    path: 'cost-centers',
    component: CostCenters,
    meta: {
      access: ['org.costCenter.view']
    },
    children: [
      {
        name: 'cost-center-edit',
        path: ':costCenterId/edit',
        components: {
          modal: CostCenterDetails
        },
        meta: {
          showModal: true,
          access: ['org.costCenter.manage']
        }
      },
      {
        name: 'cost-center-new',
        path: 'new',
        components: {
          modal: CostCenterDetails
        },
        meta: {
          showModal: true,
          access: ['org.costCenter.manage']
        }
      }
    ]
  }
]
